import * as Realm from 'realm-web';
import {Auth} from '@aws-amplify/auth';

export const APP_ID = 'manufacturing-agkus';
const graphqlUrl = `https://realm.mongodb.com/api/client/v2.0/app/${APP_ID}/graphql`;

// Connect to your MongoDB Realm app
const app = new Realm.App(APP_ID);

// Get a valid Realm user access token to authenticate requests
async function getValidAccessToken(): Promise<string> {
  if (!app.currentUser) {
    // If no user is logged in, log in an anonymous user
    let authenticatedUser = await Auth.currentAuthenticatedUser();
    console.log("Got authenticated user: " + JSON.stringify(authenticatedUser));
    await app.logIn(Realm.Credentials.jwt(authenticatedUser.signInUserSession.idToken.jwtToken));
  } else {
    // The logged in user's access token might be stale,
    // Refreshing custom data also refreshes the access token
    await app.currentUser.refreshCustomData();
  }
  // Get a valid access token for the current user
  localStorage.setItem('token', app.currentUser.accessToken);
  return app.currentUser.accessToken;
}

export {
  graphqlUrl,
  getValidAccessToken
};
